import RastreamentoLink from '@/components/global/RastreamentoLink';
import { Container, Item } from './styles';

import Rastreamento from '../../../../images/icons/rastreamento';
import Cotacao from '../../../../images/icons/cotacao.svg';
import Coleta from '../../../../images/icons/coleta.svg';
import ViaBoleto from '../../../../images/icons/2-via-boleto.svg';
import Dacte from '../../../../images/icons/dacte.svg';
import XML from '../../../../images/icons/xml.svg';

const Sidebar = (): JSX.Element => {
  return (
    <Container>
      <Item as={RastreamentoLink} selected>
        <Rastreamento /> Rastreamento
      </Item>
      <Item
        href="https://api.whatsapp.com/send?phone=556235861151&text=Preciso%20de%20uma%20cota%C3%A7%C3%A3o%20de%20frete"
        target="_blank"
        rel="noreferrer"
      >
        <Cotacao /> Fazer cotação
      </Item>
      <Item
        href="https://api.whatsapp.com/send?phone=556299851496&text=Preciso%20marcar%20uma%20coleta"
        target="_blank"
        rel="noreferrer"
      >
        <Coleta /> Solicitar coleta
      </Item>
      <Item
        href="https://ssw.inf.br/2/servico?id=53&"
        target="_blank"
        rel="noreferrer"
      >
        <ViaBoleto /> 2ª via de boleto
      </Item>
      <Item
        href="https://ssw.inf.br/2/servico?id=51&"
        target="_blank"
        rel="noreferrer"
      >
        <Dacte /> Emitir DACTE
      </Item>
      <Item
        href="https://ssw.inf.br/2/servico?id=52&"
        target="_blank"
        rel="noreferrer"
      >
        <XML /> Baixar XML
      </Item>
    </Container>
  );
};

export default Sidebar;
